import script from "./Screen.vue?vue&type=script&setup=true&lang=js"
export * from "./Screen.vue?vue&type=script&setup=true&lang=js"

import "./Screen.vue?vue&type=style&index=0&id=4847d7db&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4847d7db"]])

export default __exports__